import * as React from "react";
const SvgFiRrFaceMonocle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-monocle_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0 .733-.066 1.467-.198 2.181a1 1 0 0 1-1.967-.361c.109-.595.165-1.207.165-1.819 0-5.514-4.486-10-10-10S2 6.486 2 12s4.486 10 10 10c.927 0 1.844-.127 2.728-.376a1 1 0 1 1 .544 1.923c-1.061.3-2.162.452-3.272.452C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12M7 16c.948 0 3.465 0 5.168 2.555a1 1 0 1 0 1.664-1.11C12.308 15.159 10.009 14 7 14a1 1 0 1 0 0 2m.5-6a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 7.5 10m12.5.5V23a1 1 0 1 1-2 0v-8.762a4.47 4.47 0 0 1-2.5.762 4.505 4.505 0 0 1-4.5-4.5C11 8.019 13.019 6 15.5 6S20 8.019 20 10.5m-2 0C18 9.121 16.878 8 15.5 8a2.503 2.503 0 0 0-2.5 2.5c0 1.379 1.122 2.5 2.5 2.5s2.5-1.121 2.5-2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-monocle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceMonocle;
